import polylineUtil from '@mapbox/polyline';
import { length, along } from '@turf/turf';
import { range } from 'lodash';
import mapboxgl from 'mapbox-gl';

export default class DistancePopupSet {
  constructor({ map, encodedPolyline, distanceUnits, showOnLoad = false, interval = null }) {
    this.map = map;

    const lineStringFeature = polylineUtil.toGeoJSON(encodedPolyline);
    const totalDistance = length(lineStringFeature, { units: distanceUnits });
    let intervalValue;

    if (interval) {
      intervalValue = interval;
    } else {
      intervalValue = this._resolveInterval({ totalDistance });
    }

    const intervals = range(0, totalDistance, intervalValue);
    intervals.shift(); // First interval is the starting point
    this.distancePopups = intervals.map((interval) => {
      const point = along(lineStringFeature, interval, { units: distanceUnits });
      const popup = new mapboxgl.Popup({
        closeOnClick: false,
        closeButton: false,
        focusAfterOpen: false,
        className: 'distance-popup'
      })
        .setLngLat(point.geometry.coordinates)
        .setHTML(`<span>${interval}</span>`);
      return popup;
    });

    if (showOnLoad) this.toggle();
  }

  isShowing() {
    return this.distancePopups.some(popup => popup.isOpen());
  }

  toggle() {
    this.distancePopups.forEach((popup) => {
      if (popup.isOpen()) {
        popup.remove();
      } else {
        popup.addTo(this.map);
      }
    });
  }

  remove() {
    this.distancePopups.forEach((popup) => {
      if (popup.isOpen()) popup.remove();
    });
  }

  _resolveInterval({ totalDistance }) {
    const minOffset = 1, multiplier = 5, maxShown = 10;
    let count, interval, i = 0;

    do {
      interval = Math.max(minOffset, minOffset * multiplier * i);
      count = Math.floor(totalDistance / interval);
      i++;
    } while (count > maxShown);

    return interval;
  }
}
